export const slides = [
  {
    id: 1,
    title: "Proven Track Record",
    description: "Thousands of satisfied clients and successful applications.",
  },
  {
    id: 2,
    title: "Why Choose Us?",
    description:
      "We stand apart because of our unwavering commitment to your success.",
  },
  {
    id: 3,
    title: "Client Focus",
    description: "Our strategies are designed to meet your unique needs.",
  },
];
